import React, { useEffect, useState } from "react";
import coinGecko from "../../assets/js/coinGecko";
import { Link } from 'react-scroll';
import Timer from "./Timer";
import "./css/Banner.css";

const Banner = (props) => {

    const [currency, setCurrency] = useState(props.currency)
    const [isLoading, setIsLoading] = useState(true)
    const [trxData, setTRXData] = useState([])

    useEffect(() => {

        const fetchcoinDetails = async () => {

            let trxPriceData

            setIsLoading(true)
            trxPriceData = await coinGecko.get("/coins/markets", {
                params: {
                    vs_currency: currency,
                    ids: "tron"
                }
            })

            setTRXData(trxPriceData.data[0])


        }

        fetchcoinDetails()
        checkUpdate()
        setIsLoading(false)

    }, [currency])

    const checkUpdate = () => {
        setInterval(() => {
            if (window.localStorage.getItem('CurrentCurrency')) {
                setCurrency(window.localStorage.getItem('CurrentCurrency'));
            }
        }, 1000)
    }

    const renderBanner = () => {
        if (isLoading === true || trxData.length === 0) {
            return <div>Loading...</div>
        } else {
            let stage;
            switch (props.stage) {
                case -1: {
                    stage = <b>ICO STARTS IN:</b>
                    break;
                }
                case 0: {
                    stage = <b>BONUS STAGE 1 ENDS IN:</b>
                    break;
                }
                case 1: {
                    stage = <b>BONUS STAGE 2 ENDS IN:</b>
                    break;
                }
                case 2: {
                    stage = <b>BONUS STAGE 3 ENDS IN:</b>
                    break;
                }
                case 3: {
                    stage = <b>BONUS STAGE 4 ENDS IN:</b>
                    break;
                }
                case 4: {
                    stage = <b>BONUS STAGE 5 ENDS IN:</b>
                    break;
                }
                case 5: {
                    stage = <b>LAST BONUS STAGE ENDS IN:</b>
                    break;
                }
                case 404: {
                    stage = <b>ERROR</b>
                    break;
                }
                default: {
                    stage = <b>INVALID</b>
                }
            }
            return (
                <div className="banner-wrapper">
                    <div className="container me-padder-top">
                        <div
                            className="row align-items-center justify-content-center justify-content-lg-between gutter-vr-60px">
                            <div className="col-lg-6 col-xl-6 text-center text-lg-left">
                                <div className="banner-caption">
                                    <div className="cpn-head mt-0">
                                        <h1 className="title title-thin title-xl-2">
                                            Enjoy transfer in seconds and settlement on the TRON blockchain Wallet.
                                        </h1>
                                    </div>
                                    <div className="cpn-text cpn-text-s2">
                                        <p className="lead-s2 lead-light">
                                            Full transparency. More trust, Minimize risk,
                                            maximize rewards.
                                        </p>
                                    </div>
                                    <div className="cpn-btns">
                                        <Link
                                            activeClass="active"
                                            to="buytokens-wrapper"
                                            spy={true}
                                            smooth={true}
                                            offset={-70}
                                            duration={500}
                                        ><button className="me-btn">Buy Tokens</button></Link>
                                        <button className="me-btn" >Whitepaper</button>
                                    </div>
                                    <div className="cpn-social">
                                        <h4 className="title-xs">JOIN OUR COMMUNITY</h4>
                                        <ul className="social">
                                            <li>
                                                <a href="/"><em className="social-icon fas fa-paper-plane"></em></a>
                                            </li>
                                            <li>
                                                <a href="/"><em className="social-icon fab fa-facebook-f"></em></a>
                                            </li>
                                            <li>
                                                <a href="/"><em className="social-icon fab fa-twitter"></em></a>
                                            </li>
                                            <li>
                                                <a href="/"><em className="social-icon fab fa-github"></em></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-5 col-md-8 col-sm-9">
                                <div className="token-status token-status-s3">
                                    <h4 className="title-md dialog">{stage}</h4>
                                    <div className="countdown-s2">
                                        <Timer
                                            timeDifference={props.timeDifference}
                                        />
                                        <div className="date-txt">
                                            <span>DAYS</span>
                                            <span>HOURS</span>
                                            <span>MINS</span>
                                            <span>SECS</span>
                                        </div>
                                    </div>
                                    <div className="token-info token-info-s1">
                                        <div className="token-info-item token-info-item-s1">
                                            <div className="token-info-item-list">
                                                <span>Token Price:</span>
                                                <h4><b>1 CHY=
                                                    {currency === 'inr' && trxData.current_price.toFixed(2) ? `₹` : `$`}
                                                    {trxData.current_price.toFixed(2)}</b></h4>
                                            </div>
                                            <div className="token-info-item-list">
                                                <span>We Accept:</span>
                                                <h4><b><em className="fas fa-rupee-sign"></em> INR</b></h4>
                                            </div>
                                        </div>
                                        <div className="token-info-item token-info-item-s1">
                                            <span>Tokens Available : </span>
                                            <h4>{props.tokensAvailable} CHY</h4>
                                        </div>
                                    </div>
                                    <hr className="token-info-partition"></hr>
                                    <div className="token-action token-action-s2 flex-wrap flex-sm-nowrap">
                                        <div className="token-min-s2">
                                            <span>Minimum Purchase: </span>
                                            <span><b> 10,000 CHY</b></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            )

        }
    }



    return (
        <>
            {renderBanner()}
        </>
    );
}


export default Banner;